import { useContext } from 'react';
import { CounterContext } from '@modules/counter';

export const useCounter = () => {
  return useContext(CounterContext);
};
